import RU from './ru_RU';
import EN from './en_US';

export default {
  'ru-RU': RU,
  'en-US': EN,
};
